"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const router_1 = __importDefault(require("./router"));
const store_1 = __importDefault(require("./store"));
require("@/assets/css/reset.css");
require("@/assets/css/sprite.scss");
const toast_1 = __importDefault(require("@/plugins/toast/"));
require("./plugins/element.js");
require("./plugins/vuescroll");
require("@/assets/css/element.css");
vue_1.default.use(toast_1.default, {});
vue_1.default.config.productionTip = false;
vue_1.default.prototype.$EventBus = new vue_1.default();
new vue_1.default({
    router: router_1.default,
    store: store_1.default,
    render: h => h('router-view'),
}).$mount('#app');
